import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ReportsIcon from "@mui/icons-material/Unarchive";
import Divider from "@mui/material/Divider";
import AssignPrescriptionIcon from "@mui/icons-material/NoteAdd";
import { Link } from "@reach/router";
import USER_ROLES from "../common/userroles";
import { withTranslation } from "react-i18next";
import connectionType from "../common/connection-type";

const styles = (theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  textColor: {
    color: "black",
  },
  listItem: {
    "&.MuiButtonBase-root": {
      display: "flex",
      padding: "8px 24px 8px 24px",
    },
  },
});

class NestedList extends React.Component {
  state = {
    open: false,
    Dashboard: false,
    // assignprescription: true,
    reports: true,
    assigneditemsreports: true,
    stockeditemsreports: true,
    cancelledItemsReports: true,
    pickedUpitemsreports: true,
    transactionsreports: true,
    enrolledPatientsreports: true,
    DeliveryTech: false,
    isIpayTransactionAllowed: true,
    isIpayReceivablesAllowed: true,
    isTemperatureMonitoringAllowed: true,
    isReturnToStockAllowed: true,
    isSurveyReportAllowed: true,
    isConsultationReportAllowed: true,
    isScheduleConsultationAllowed: true,
    isOutForDeliveryAllowed: true,
    isDeliveredItemsAllowed: true,
    isLoyaltiMembersAllowed: true,
    isOrderStagingViewAllowed: true,
    isConsoleReportAllowed: true,
    payrollDeductionsreports: true,
    inActiveUsresAllowed: true,
    kioskUtilizationAllowed: true,
    isPhiLogsVisible: false,
    isPurgeTrailVisible: false,
    isCycleReview: false,
    isAuditTrailReportAllowed: false,
    isDeliverPrescriptionVisible: false,
    isHL7OrdersViewVisible: false,
    isComplianceReconciliation: false
  };
  handleClick = () => {
    this.setState((state) => ({ open: !state.open }));
  };
  componentDidMount() {
    let permissions = JSON.parse(sessionStorage.getItem("permissions"));
    let _checkUserRole = JSON.parse(sessionStorage.getItem("superadmin"));
    // let _isRetailLocal = localStorage.getItem("isRetail");
    // let _isRetail;
    // if (![undefined, undefined, null, null, ""].includes(_isRetailLocal)) {
    //   _isRetail = [true, "true"].includes(_isRetailLocal) ? true : false;
    // } else {
    //   _isRetail = false;
    // }
    // if (_checkUserRole !== USER_ROLES.SUPERADMIN) {
    //   if (permissions && permissions.length > 0) {
    //     let permissionObj = {};
    //     permissions.map((item) => {
    //       return item.name.trim() === "Weekly Total"
    //         ? (permissionObj.weeklyTotal = true)
    //         : item.name.trim() === "Sales"
    //         ? (permissionObj.sales = true)
    //         : item.name.trim() === "Accounts"
    //         ? (permissionObj.accounts = true)
    //         : item.name.trim() === "Daily Sales States"
    //         ? (permissionObj.dailySalesStates = true)
    //         : item.name.trim() === "Consultations"
    //         ? (permissionObj.consultations = true)
    //         : item.name.trim() === "View"
    //         ? (permissionObj.view = true)
    //         : item.name.trim() === "Assign"
    //         ? (permissionObj.assign = true)
    //         : item.name.trim() === "UnAssign"
    //         ? (permissionObj.unAssign = true)
    //         : item.name.trim() === "Delete"
    //         ? (permissionObj.delete = true)
    //         : item.name.trim() === "Assigned Items"
    //         ? (permissionObj.assigned = true)
    //         : item.name.trim() === "Stocked Items"
    //         ? (permissionObj.stocked = true)
    //         : item.name.trim() === "Picked Up Items"
    //         ? (permissionObj.pickedUpItems = true)
    //         : item.name.trim() === "Transactions"
    //         ? (permissionObj.transactions = true)
    //         : item.name.trim() === "Cancelled Items"
    //         ? (permissionObj.cancelledItems = true)
    //         : null;
    //     });
    //     if (
    //       permissionObj.weeklyTotal &&
    //       permissionObj.sales &&
    //       permissionObj.accounts &&
    //       permissionObj.dailySalesStates &&
    //       permissionObj.consultations
    //     ) {
    //       this.setState({ Dashboard: true });
    //     } else {
    //       this.setState({ Dashboard: false });
    //     }
    //     if (
    //       permissionObj.view &&
    //       permissionObj.assign &&
    //       permissionObj.unAssign &&
    //       permissionObj.delete
    //     ) {
    //       this.setState({ assignprescription: true });
    //     } else {
    //       this.setState({ assignprescription: false });
    //     }
    //     let permissionUser = JSON.parse(
    //       sessionStorage.getItem("permissionUser")
    //     );
    //     if (permissionUser === USER_ROLES.DELIVERYTECH) {
    //       this.setState({ DeliveryTech: true });
    //     }
    //   } else {
    //     this.setState({ Dashboard: false });
    //     this.setState({ assignprescription: false });
    //     this.setState({ reports: false });
    //   }
    // }

    /** Report Permission Start Here */
    if (permissions && permissions.length > 0) {
      if (_checkUserRole === USER_ROLES.SUPERADMIN) {
        this.setState({
          Dashboard: true,
          assigneditemsreports: true,
          stockeditemsreports: true,
          pickedUpitemsreports: true,
          transactionsreports: true,
          isIpayTransactionAllowed: true,
          isTemperatureMonitoringAllowed: true,
          isReturnToStockAllowed: true,
          isSurveyReportAllowed: true,
          isConsultationReportAllowed: true,
          isScheduleConsultationAllowed: true,
          isOutForDeliveryAllowed: true,
          isDeliveredItemsAllowed: true,
          isLoyaltiMembersAllowed: true,
          isOrderStagingViewAllowed: true,
          isConsoleReportAllowed: true,
          enrolledPatientsreports: true,
          payrollDeductionsreports: true,
          inActiveUsresAllowed: true,
          kioskUtilizationAllowed: true,
          isPhiLogsVisible: true,
          isPurgeTrailVisible: true,
          isCycleReview: true,
          cancelledItemsReports: true,
          isAuditTrailReportAllowed: true,
          isHL7OrdersViewVisible: true,
          isIpayReceivablesAllowed: true,
          isDeliverPrescriptionVisible: true,
          isComplianceReconciliation: true
        });
      } else {
        this.setState({
          Dashboard: true,
          assigneditemsreports: permissions.some((item) => item.name.trim() === "Assigned Items" && item.is_allowed === 1),
          stockeditemsreports: permissions.some((item) => item.name.trim() === "Stocked Items" && item.is_allowed === 1),
          pickedUpitemsreports: permissions.some((item) => item.name.trim() === "Picked Up Items" && item.is_allowed === 1),
          transactionsreports: permissions.some((item) => item.name.trim() === "Transactions" && item.is_allowed === 1),
          isIpayTransactionAllowed: permissions.some((item) => item.name.trim() === "iPay Transactions" && item.is_allowed === 1),
          isTemperatureMonitoringAllowed: permissions.some((item) => item.name.trim() === "Temperature Monitoring" && item.is_allowed === 1),
          isReturnToStockAllowed: permissions.some((item) => item.name.trim() === "Return to stock" && item.is_allowed === 1),
          isSurveyReportAllowed: permissions.some((item) => item.name.trim() === "Survey Report" && item.is_allowed === 1),
          isConsultationReportAllowed: permissions.some((item) => item.name.trim() === "Consultation Report" && item.is_allowed === 1),
          isScheduleConsultationAllowed: permissions.some((item) => item.name.trim() === "Schedule Consultation" && item.is_allowed === 1),
          isOutForDeliveryAllowed: permissions.some((item) => item.name.trim() === "Out for Delivery" && item.is_allowed === 1),
          isDeliveredItemsAllowed: permissions.some((item) => item.name.trim() === "Delivered Items" && item.is_allowed === 1),
          isLoyaltiMembersAllowed: permissions.some((item) => item.name.trim() === "Loyalty Members" && item.is_allowed === 1),
          isOrderStagingViewAllowed: permissions.some((item) => item.name.trim() === "Order Staging View" && item.is_allowed === 1),
          isConsoleReportAllowed: permissions.some((item) => item.name.trim() === "Console Report" && item.is_allowed === 1),
          enrolledPatientsreports: permissions.some((item) => item.name.trim() === "Patient List" && item.is_allowed === 1),
          payrollDeductionsreports: permissions.some((item) => item.name.trim() === "Payroll Deduction" && item.is_allowed === 1),
          inActiveUsresAllowed: permissions.some((item) => item.name.trim() === "InActive Users" && item.is_allowed === 1),
          kioskUtilizationAllowed: permissions.some((item) => item.name.trim() === "Kiosk Utilization" && item.is_allowed === 1),
          isPhiLogsVisible: permissions.some((item) => item.name.trim() === "PMS Logs" && item.is_allowed === 1),
          isPurgeTrailVisible: permissions.some((item) => item.name.trim() === "Purge trail" && item.is_allowed === 1),
          isCycleReview: permissions.some((item) => item.name.trim() === "Cycle Review" && item.is_allowed === 1),
          cancelledItemsReports: permissions.some((item) => item.name.trim() === "Cancelled Items" && item.is_allowed === 1),
          isAuditTrailReportAllowed: permissions.some((item) => item.name.trim() === "Audit trail" && item.is_allowed === 1),
          isHL7OrdersViewVisible: permissions.some((item) => item.name.trim() === "HL7 Order Staging" && item.is_allowed === 1),
          isIpayReceivablesAllowed: permissions.some((item) => item.name.trim() === "iPay Receivables" && item.is_allowed === 1),
          // isDeliverPrescriptionVisible: permissions.some((item) => item.permission_entity_type.trim() === "Assign Prescription" && item.is_allowed === 1),
          isDeliverPrescriptionVisible: permissions.some((item) => item.name.trim() === "Assign" && item.is_allowed === 1),
          isComplianceReconciliation: permissions.some((item) => item.name.trim() === "Compliance Reconciliation" && item.is_allowed === 1),
        });

      }
    } else {
      this.setState({
        Dashboard: false,
        assigneditemsreports: false,
        stockeditemsreports: false,
        pickedUpitemsreports: false,
        transactionsreports: false,
        isIpayTransactionAllowed: false,
        isTemperatureMonitoringAllowed: false,
        isReturnToStockAllowed: false,
        isSurveyReportAllowed: false,
        isConsultationReportAllowed: false,
        isScheduleConsultationAllowed: false,
        isOutForDeliveryAllowed: false,
        isDeliveredItemsAllowed: false,
        isLoyaltiMembersAllowed: false,
        isOrderStagingViewAllowed: false,
        isConsoleReportAllowed: false,
        enrolledPatientsreports: false,
        payrollDeductionsreports: false,
        inActiveUsresAllowed: false,
        kioskUtilizationAllowed: false,
        isPhiLogsVisible: false,
        isPurgeTrailVisible: false,
        isCycleReview: false,
        cancelledItemsReports: false,
        isAuditTrailReportAllowed: false,
        isHL7OrdersViewVisible: false,
        isIpayReceivablesAllowed: false,
        isDeliverPrescriptionVisible: false,
        isComplianceReconciliation: false
      });
    }
  }
  render() {
    const { classes, t } = this.props;
    const {
      isIpayTransactionAllowed,
      isIpayReceivablesAllowed,
      isTemperatureMonitoringAllowed,
      isReturnToStockAllowed,
      isSurveyReportAllowed,
      isConsultationReportAllowed,
      isScheduleConsultationAllowed,
      isOutForDeliveryAllowed,
      isDeliveredItemsAllowed,
      isLoyaltiMembersAllowed,
      isOrderStagingViewAllowed,
      isConsoleReportAllowed,
      payrollDeductionsreports,
      inActiveUsresAllowed,
      kioskUtilizationAllowed,
      isPhiLogsVisible,
      isPurgeTrailVisible,
      isCycleReview,
      isAuditTrailReportAllowed,
      isDeliverPrescriptionVisible,
      isHL7OrdersViewVisible,
      isComplianceReconciliation
    } = this.state;
    const _isRetail = localStorage.getItem("isRetail");
    const accountConnectionId = sessionStorage.getItem("accountConnectionId");
    return (
      <div id="react-no-print">
        {this.state.Dashboard === true && !this.state.DeliveryTech ? (
          <Link
            to={
              [
                false,
                "false",
                undefined,
                "undefined",
                null,
                "null",
                "",
              ].includes(_isRetail)
                ? "/home/"
                : "/home/dashboard"
            }
            style={{ textDecoration: "none" }}
          >
            <ListItemButton className={classes.listItem}>
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText
                primary={t("Leftbar.Dashboard")}
                className={classes.textColor}
              />
            </ListItemButton>
          </Link>
        ) : (
          ""
        )}

        {/* {isDeliverPrescriptionVisible ? (
          <React.Fragment>
            <Divider />
            {[
              false,
              "false",
              undefined,
              "undefined",
              null,
              "null",
              "",
            ].includes(_isRetail) ? (
              <div>
                {this.state.assignprescription === true &&
                !this.state.DeliveryTech ? (
                  this.props.isVisible === true ? (
                    <Link
                      to="/home/prescription/unpluggedassign"
                      style={{ textDecoration: "none" }}
                    >
                      <ListItemButton className={classes.listItem}>
                        <ListItemIcon>
                          <AssignPrescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={t("Leftbar.DeliverPrescription")}
                          className={classes.textColor}
                        />
                      </ListItemButton>
                    </Link>
                  ) : (
                    <Link
                      to="/home/prescription/assign"
                      style={{ textDecoration: "none" }}
                    >
                      <ListItemButton className={classes.listItem}>
                        <ListItemIcon>
                          <AssignPrescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={t("Leftbar.DeliverPrescription")}
                          className={classes.textColor}
                        />
                      </ListItemButton>
                    </Link>
                  )
                ) : (
                  ""
                )}
              </div>
            ) : (
              <Link
                to={
                  [
                    false,
                    "false",
                    undefined,
                    "undefined",
                    null,
                    "null",
                    "",
                  ].includes(_isRetail)
                    ? "/home/create-orders"
                    : "/home/"
                }
                style={{ textDecoration: "none" }}
              >
                <ListItemButton className={classes.listItem}>
                  <ListItemIcon>
                    <AssignPrescriptionIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={t("Leftbar.CreateLockerPickup")}
                    className={classes.textColor}
                  />
                </ListItemButton>
              </Link>
            )}
          </React.Fragment>
        ) : null} */}
        {isDeliverPrescriptionVisible ? (
          <React.Fragment>
            <Divider />
              <div>
                {!this.state.DeliveryTech ? (
                  this.props.isVisible === true ? (
                    <Link
                      to="/home/prescription/unpluggedassign"
                      style={{ textDecoration: "none" }}
                    >
                      <ListItemButton className={classes.listItem}>
                        <ListItemIcon>
                          <AssignPrescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={t("Leftbar.DeliverPrescription")}
                          className={classes.textColor}
                        />
                      </ListItemButton>
                    </Link>
                  ) : (
                    <Link
                      to="/home/prescription/assign"
                      style={{ textDecoration: "none" }}
                    >
                      <ListItemButton className={classes.listItem}>
                        <ListItemIcon>
                          <AssignPrescriptionIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={t("Leftbar.DeliverPrescription")}
                          className={classes.textColor}
                        />
                      </ListItemButton>
                    </Link>
                  )
                ) : (
                  ""
                )}
              </div>
          </React.Fragment>
        ) : null}
        {this.state.reports === true && !this.state.DeliveryTech ? (
          <React.Fragment>
            <ListItemButton
              onClick={this.handleClick}
              className={classes.listItem}
            >
              <ListItemIcon>
                <ReportsIcon />
              </ListItemIcon>
              <ListItemText
                inset
                primary={t("Leftbar.Report")}
                className={classes.textColor}
                style={{ paddingLeft: "0px" }}
              />
              {this.state.open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={this.state.open} timeout="auto" unmountOnExit>
              {this.state.assigneditemsreports === true ? (
                <Link
                  to="/home/reports/assigned-items/assigneditems"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.AssignedItemReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {this.state.stockeditemsreports === true ? (
                <Link
                  to="/home/reports/stock-list/StockLists"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.StockedItemReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {this.state.pickedUpitemsreports === true ? (
                <Link
                  to="/home/reports/pickup/PickUpLists"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.PickupItemReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {this.state.cancelledItemsReports === true && (
                <Link
                  to="/home/reports/cancelled-list/CancelledLists"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.CancelledItemsReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              )}
              {this.state.transactionsreports === true ? (
                <Link
                  to="/home/reports/transaction/TransactionLists"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.TransactionsReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {this.state.enrolledPatientsreports === true ? (
                <Link
                  to="/home/reports/enrolled-patients/enrolledpatients"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.PatientListReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {payrollDeductionsreports && (
                <Link
                  to="/home/reports/payroll-deductions/payrollDeductions"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.PayrollDeductionReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              )}
              {isReturnToStockAllowed ? (
                <Link
                  to="/home/reports/return-to-stock/items"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.RetrunToStockItemsReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isSurveyReportAllowed ? (
                <Link
                  to="/home/reports/survey-report/surveyreport"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.SurveyItemReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isConsultationReportAllowed ? (
                <Link
                  to="/home/reports/consultation/consultreport"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.ConsultationReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isScheduleConsultationAllowed ? (
                <Link
                  to="/home/reports/consultation/scheduleconsultreport"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.ScheduleReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isOutForDeliveryAllowed ? (
                <Link
                  to="/home/reports/out-of-delivery/delivery"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.OutForDeliveryReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isDeliveredItemsAllowed ? (
                <Link
                  to="/home/reports/my-delivery/delivery"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.DeliveredItemReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isIpayTransactionAllowed ? (
                <Link
                  to="/home/reports/transaction/ipaytransactions"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.iPayReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}

              {isIpayReceivablesAllowed ? (
                <Link
                  to="/home/reports/transaction/ipayreceivables"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.iPayReceivableReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {isTemperatureMonitoringAllowed ? (
                <Link
                  to="/home/reports/temperaturemonitoring"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.TemperatureReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {isLoyaltiMembersAllowed ? (
                <Link
                  to="/home/reports/enrolled-loyalty-members"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.LoyaltyReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}

              {isOrderStagingViewAllowed ? (
                <Link
                  to="/home/reports/orders-view"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.OrderStagingReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isConsoleReportAllowed ? (
                <Link
                  to="/home/reports/console-report"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.ConsoleReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {inActiveUsresAllowed && (
                <Link
                  to="/home/reports/inactive-users-report"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.InactiveUserReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              )}
              {kioskUtilizationAllowed && (
                <Link
                  to="/home/reports/kiosk-utilization"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.KioskUtilReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              )}
              {isPhiLogsVisible ? (
                <Link
                  to="/home/reports/phi-logs"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.PhiLogs")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {accountConnectionId === connectionType.THIRD_PARTY ? (
                <Link
                  to="/home/reports/vendor-orders"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.VendorOrdersReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isAuditTrailReportAllowed ? (
                <Link
                  to="/home/reports/audit-trail"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.AuditReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isPurgeTrailVisible ? (
                <Link
                  to="/home/reports/purge-trail-report"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Report.purgeTrail.ReportTitle")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isCycleReview ? (
                <Link
                  to="/home/reports/cycle-report"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Report.CycleReview")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {isHL7OrdersViewVisible ? (
                <Link
                  to="/home/reports/hl7-orders"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.HLOrderStagingReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
                <Link
                  to="/home/reports/message-log"
                  style={{ textDecoration: "none" }}
                >
                <List component="div" disablePadding>
                  <ListItemButton className={classes.listItem}>
                    <ListItemText
                      inset
                      primary={t("Report.MessageLog.MessageLogTitle")}
                      className={classes.textColor}
                    />
                  </ListItemButton>
                </List>
              </Link>
              {isComplianceReconciliation ? (
                <Link
                  to="/home/reports/ComplianceReconciliationList"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Report.ComplianceReconciliation")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>) : null}
            </Collapse>
          </React.Fragment>
        ) : (
          ""
        )}
      </div>
    );
  }
}

NestedList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(NestedList));



// WEBPACK FOOTER //
// ./src/components/leftnav/reportlink.js